<template>
  <div class="container my-3 my-md-5">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <a href="/export/deliverynoteopenpositions" type="button" class="btn btn-primary mt-2 ml-1">Offene Lieferscheinpositionen (CSV)</a>
            <a href="/export/deliverynoteopenpositionstxt" type="button" class="btn btn-primary mt-2 ml-1">Offene Lieferscheinpositionen (TXT)</a>
            <a href="/export/deathcertificates" type="button" class="btn btn-primary mt-2 ml-1">Totenscheine (CSV)</a>
            <a href="/export/backorderbyvendor/xlsx" type="button" class="btn btn-primary mt-2 ml-1">Backorder nach Händlern (XLSX)</a>
            <a href="/export/backordertoprocess/xlsx" type="button" class="btn btn-primary mt-2 ml-1">Backorder zu bearbeiten (XLSX)</a>
            <a href="/export/backordercomplete/xlsx" type="button" class="btn btn-primary mt-2 ml-1">Backorder komplett (XLSX)</a>
            <a href="/export/backorderwoinbound/xlsx" type="button" class="btn btn-primary mt-2 ml-1">Backorder komplett ohne Zulauf (XLSX)</a>
            <a href="/export/inboundshipments/xlsx" type="button" class="btn btn-primary mt-2 ml-1">Zulauf (XLSX)</a>
						<b-btn class="mt-2 ml-1"
						variant="primary"
						@click="getExportdata('/export/sales/blocked/xlsx',
						'BlockerSales_'+ moment().format('DD.MM.YYYY')+ '.xlsx',
						'getBlockedSales',
						'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')"
						:disabled="activeOperation === 'getBlockedSales'">
							Verkäufe auf blockierten Marktplätzen (XLSX)
							<b-spinner v-if="activeOperation === 'getBlockedSales'" small></b-spinner>
						</b-btn>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mt-3">
          <div class="card-body">
            <b-input-group>
							<multi-select
									class="mb-2"
									:value="selectedVendors"
									@input="selectedVendors = $event"
									:options="mappedVendors"
									:multiple="true"
									label="text"
									track-by="value"
									:close-on-select="false"
									:searchable="false"
									:select-label="''"
									:deselect-label="''"
									:selected-label="'✓'"
									placeholder="Suche"
									style="height: calc(1.5em + 0.5rem + 2px); max-width: 27%"
							>
								<template #selection="{ search, values, isOpen }">
									<div class=" align-items-center" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
							<span
									v-for="option in values"
									:key="option.value"
									class="p-1 position-relative"
									style="font-size: 1rem; font-weight: normal !important;"
							>
								{{ option.text}}
							</span>
										<input
												v-if="isOpen"
												type="text"
												class="border-0 shadow-none"
												style="min-width: 100px; background: transparent;"
										/>
									</div>
								</template>
								<template #singleLabel>
									<span class="d-flex align-items-center"></span>
								</template>
								<template #placeholder>
									<span>Händlerauswahl</span>
								</template>
								<template v-slot:caret="{ toggle }">
									<div class="multiselect__select" @mousedown.prevent.stop="toggle">
							<span class="d-flex align-items-center justify-content-center">
							</span>
									</div>
								</template>
								<template v-slot:option="{ option }">
									{{ option.text }}
								</template>
							</multi-select>
            </b-input-group>
            <br>
            <b-btn class="mt-2" variant="primary" @click="getSalesStatistic" :disabled="activeOperation === 'SalesStatistic'">
              SalesExport <b-spinner v-if="activeOperation === 'SalesStatistic'" size="sm"></b-spinner>
            </b-btn>
          </div>
        </div>
      </div>
    </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card mt-3">
            <div class="card-body">
              <b-input-group>
                <b-form-input class="col-3" v-model="selectedYear"></b-form-input>
                <b-input-group-append>
                  <b-dropdown id="dropdown-1" class="" variant="primary">
                    <b-dropdown-item v-for="year in allYears" :key="year" @click="setYear(year)">{{year}}</b-dropdown-item>
                  </b-dropdown>
                </b-input-group-append>
              </b-input-group>
              <br>
							<b-btn class="mt-2 ml-1"
										 variant="primary"
										 @click="getExportdata('/export/packaging/'+ this.selectedYear +'/xlsx',
						'Verpackungsstatistik_'+ selectedYear + '.xlsx',
						'getYearlyPackagingStats',
						'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')"
										 :disabled="activeOperation === 'getYearlyPackagingStats'">
								Verpackung (XLSX)
								<b-spinner v-if="activeOperation === 'getYearlyPackagingStats'" small></b-spinner>
							</b-btn>
          </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card mt-3">
            <div class="card-body">
              <b-input-group class="mb-2">
                <b-form-input id="deliveryTime" v-model="formattedDate" type="text" placeholder="H:m:s D-M-Y"></b-form-input>
                  <b-input-group-append>
                  <b-form-datepicker  v-model="selectedDate" button-only right start-weekday="1" aria-controls="deliveryTime"></b-form-datepicker>
                  <b-button @click="isCollapsOpen = !isCollapsOpen" class="">Marketaccounts
	                  <i v-if="!isCollapsOpen" class="bi bi-caret-down-fill" aria-hidden="true"></i>
	                  <i v-else class="bi bi-caret-up-fill" aria-hidden="true" ></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
                <b-collapse v-model="isCollapsOpen">
                  <div v-for="marketAccount in marketAccounts" :key="marketAccount.id">
                    <b-form-checkbox
                    v-model="marketAccount.selected"
                    :value="true"
                    :unchecked-value="false"
                    >{{marketAccount.name}}
                    </b-form-checkbox>
                  </div>
                </b-collapse>
              <br>
              <b-link :href="'/export/predelivery/'+formattedDate+'/xlsx'"><b-btn variant="primary">Vorversand </b-btn></b-link>
            </div>
          </div>
        </div>
      </div>
		<div class="row">
			<div class="col-md-12">
				<div class="card mt-3">
					<div class="card-body">
						<div class="d-flex align-items-center">
							<label for="shipping-work-time-from" class="mr-2 mb-2">Von</label>
							<b-form-datepicker
									id="shipping-work-time-from"
									v-model="selectedShippingWorkTimeFromDate"
									class="mb-2"
									size="sm"
									start-weekday="1"
									locale="de-DE"
									:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }">
							</b-form-datepicker>

							<label for="shipping-work-time-to" class="mr-2 ml-2 mb-2">Bis</label>
							<b-form-datepicker
									id="shipping-work-time-to"
									v-model="selectedShippingWorkTimeToDate"
									class="mb-2"
									size="sm"
									start-weekday="1"
									locale="de-DE"
									:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }">
							</b-form-datepicker>
						</div>
						<br>
						<b-btn class="mt-2 ml-1"
									 variant="primary"
									 @click="getExportdata(
								'/export/shipping_work_time/' + selectedShippingWorkTimeFromDate + '/' + selectedShippingWorkTimeToDate + '/xlsx',
						'VersandArbeitszeit_' + formattedSelectedShippingWorkTimeFromDate + '-' + formattedSelectedShippingWorkTimeToDate + '.xlsx',
			'getShippingWorkTime',
					'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
										)"
									 :disabled="activeOperation === 'getShippingWorkTime'">
								Versandarbeitszeit
							<b-spinner v-if="activeOperation === 'getShippingWorkTime'" small></b-spinner>
						</b-btn>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<div class="card mt-3">
					<div class="card-body">
						<div class="d-flex align-items-center">
								<multi-select
										class="mb-2"
										:value="selectedDeliveryTimeVendors"
										@input="selectedDeliveryTimeVendors = $event"
										:options="mappedVendors"
										:multiple="true"
										label="text"
										track-by="value"
										:close-on-select="false"
										:searchable="false"
										:select-label="''"
										:deselect-label="''"
										:selected-label="'✓'"
										placeholder="Suche"
										style="height: calc(1.5em + 0.5rem + 2px); max-width: 40%;"
								>
									<template #selection="{ search, values, isOpen }">
										<div class=" align-items-center" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
							<span
									v-for="option in values"
									:key="option.value"
									class="p-1 position-relative"
									style="font-size: 1rem; font-weight: normal !important;"
							>
								{{ option.text}}
							</span>
											<input
													v-if="isOpen"
													type="text"
													class="border-0 shadow-none"
													style="min-width: 100px; background: transparent;"
											/>
										</div>
									</template>
									<template #singleLabel>
										<span class="d-flex align-items-center"></span>
									</template>
									<template #placeholder>
										<span>Händlerauswahl</span>
									</template>
									<template v-slot:caret="{ toggle }">
										<div class="multiselect__select" @mousedown.prevent.stop="toggle">
							<span class="d-flex align-items-center justify-content-center">
							</span>
										</div>
									</template>
									<template v-slot:option="{ option }">
										{{ option.text }}
									</template>
								</multi-select>
								<div id="datepicker" class="d-flex">
									<label for="select-date-range-from" class="mr-2 text-right col">von</label>
									<b-form-datepicker
											id="date-range-from"
											class="mb-2 col-6"
											size="sm"
											:state="validateDateRange"
											v-model="dateFrom"
											:date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }">
									</b-form-datepicker>

									<label for="select-date-range-to" class="mr-2 text-right col">bis</label>
									<b-form-datepicker
											id="date-range-to"
											class="mb-2 col-6"
											size="sm"
											:state="validateDateRange"
											v-model="dateTo"
											:date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }">
									</b-form-datepicker>
								</div>
						</div>
						<br>
						<b-btn class="mt-2" variant="primary"
						:disabled="!validateDateRange || selectedDeliveryTimeVendors.length < 1 || activeOperation === 'evaluateDeliveryTime'"
						@click="evaluateDeliveryTime()">
						Lieferzeit auswerten <b-spinner v-if="activeOperation === 'evaluateDeliveryTime'" small></b-spinner>
						</b-btn>
					</div>
				</div>
			</div>
		</div>
    <modal-error-component v-model="modalError"></modal-error-component>
  </div>
</template>

<script>
export default {
  props: ['marketAccounts'],
  data(){
    return {
      selectedYear: null,
			selectedDate: null,
			selectedShippingWorkTimeFromDate: null,
			selectedShippingWorkTimeToDate: null,
      vendors: [],
      mappedVendors: [],
      selectedVendors: [],
      selectedDeliveryTimeVendors: [],
      selectedVendor: null,
      isCollapsOpen: false,
			dateFrom: null,
			dateTo: null,
			activeOperation: null,
			requestInProgress: false,
      modalError: {
        show: false,
        message: "unpopulated",
        error: "unpopulated",
        title: "unpopulated"
      },
    }
  },
  computed:{
    allYears(){
      const currentYear = new Date().getFullYear();
      const startYear = 2021;
      const years = [];

      for(let year = startYear; year <= currentYear; year++){
          years.push(year);
      }
      return years;
    },
    formattedDate(){
      return moment(this.selectedDate, "YYYY-MM-DD").format('DD.MM.YYYY')
    },
		formattedSelectedShippingWorkTimeFromDate: {
			get() {
				return moment(this.selectedShippingWorkTimeFromDate, 'YYYY-MM-DD').format('DD.MM.YYYY');
			},
			set(value) {
				const date = moment(value, 'DD.MM.YYYY', true);

				if (date.isValid()) {
					this.selectedShippingWorkTimeFromDate = date.format('YYYY-MM-DD');
				}
			}
		},
		formattedSelectedShippingWorkTimeToDate: {
			get() {
				return moment(this.selectedShippingWorkTimeToDate, 'YYYY-MM-DD').format('DD.MM.YYYY');
			},
			set(value) {
				const date = moment(value, 'DD.MM.YYYY', true);

				if (date.isValid()) {
					this.selectedShippingWorkTimeToDate = date.format('YYYY-MM-DD');
				}
			}
		},
		validateDateRange: function () {
			if (!this.dateFrom || !this.dateTo) return;
			const from = Date.parse(this.dateFrom);
			const to = Date.parse(this.dateTo);
			return from <= to;
		},
		mainVendors(){
			if(this.vendors.length === 0) return [];
			let vendors = [];
			vendors = this.vendors.filter(vendor => vendor.mainVendorId == null).map(vendor => {
				return {text: vendor.name, value: vendor.id}
			});
			vendors.unshift({text: "Händler auswählen", value: null, selected: true, disabled: true});
			return vendors;
		}
  },
  methods:{
    setYear(year){
      this.selectedYear = year;
    },
		getExportdata(url, filename, activeOperation, blobType){
			this.activeOperation = activeOperation;

			axios.get(url, { responseType: 'blob' })
					.then((response) => {
						const blob = new Blob([response.data], {
							type: blobType
						});
						const url = window.URL.createObjectURL(blob);
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', filename);
						document.body.appendChild(link);
						link.click();

						link.remove();
						window.URL.revokeObjectURL(url);
					})
					.catch((error) => {
						console.error("Export failed", error);
						alert("Download failed. The server might have timed out (504).");
					})
					.finally(() => {
						this.activeOperation = null;
					});
		},
    getSalesStatistic(){
    	const vendorIds = this.selectedVendors.map(vendor => Number(vendor.value));
      this.activeOperation = "SalesStatistic";
      axios.post('/export/salesStatistic', {vendorIds : vendorIds})
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'sales.csv');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
					this.activeOperation = null;
        })
        .catch(error => {
					this.activeOperation = null;
          this.modalError.show = true;
          this.modalError.title = "";
          this.modalError.message = "Beim Exportieren der Daten ist ein Fehler aufgetreten";
          this.modalError.error = error;
          console.log(error);
        });
    },
		evaluateDeliveryTime(){
			const vendorIds = this.selectedDeliveryTimeVendors.map(vendor => Number(vendor.value));
			const fromDate = moment(this.dateFrom).format("YYYY-MM-DD");
			const toDate = moment(this.dateTo).format("YYYY-MM-DD");
			this.requestInProgress = true;
			this.activeOperation = "evaluateDeliveryTime";
			axios.post('/export/deliverytime', {vendorIds: vendorIds, dateFrom: fromDate, dateTo: toDate}, {responseType: "arraybuffer"})
				.then(response => {
					const blob = new Blob([response.data], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
					});

					const url = window.URL.createObjectURL(blob);
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', 'deliverytime.xlsx');
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					this.activeOperation = null;
				})
				.catch(error => {
					this.activeOperation = null;
					this.modalError.show = true;
					this.modalError.title = "";
					this.modalError.message = "Beim Exportieren der Daten ist ein Fehler aufgetreten";
					this.modalError.error = error;
					console.log(error);
				});
		}
  },
  created(){
    this.selectedYear = new Date().getFullYear().toString();
    this.selectedDate = moment().format("YYYY-MM-DD")
		this.selectedShippingWorkTimeFromDate = moment().subtract(7, 'days').format('YYYY-MM-DD');
		this.selectedShippingWorkTimeToDate = moment().format("YYYY-MM-DD")
    axios.get('/vendor/all')
      .then(response => {
          this.vendors = response.data;
          this.mappedVendors = this.vendors.map(vendor => {
              return {text: vendor.name, value: vendor.id}
          });
      })
      .catch(error => {
          console.log(error);
      });
  },
}
</script>
